import React from 'react';

import './styles.css';

import { FaTimes, FaCheck, FaPrint } from 'react-icons/fa';

export default function ClassCallListsCardItem(props) {
    function selectStatusIcon(present) {
        if (present) return <FaCheck />
        else return <FaTimes />
    }

    return (
        <li className='class-card-call-lists-list-item'>
            {
                props.studentProfileMode ?
                    <div className='class-card-call-lists-component'>
                        <div>
                            <p className='date-time'>
                                {props.dateTime ?
                                    props.dateTime
                                    : "Data não definida"
                                }
                            </p>
                            <p className='type'>
                                {
                                    props.type ?
                                        props.type + (props.class ? ` - Turma ${props.class}` : "")
                                        : 'Tipo não definido'
                                }
                            </p>
                        </div>
                        <span className={'status-icon ' + (props.present ? 'true' : 'false') }>
                            {selectStatusIcon(props.present)}
                        </span>
                    </div>
                    :
                    <>
                    <button
                        className='class-card-call-lists-component'
                        onClick={props.showPopup}
                    >
                        <div>
                            <p className='date-time'>
                                {props.dateTime ?
                                    props.dateTime
                                    : "Data não definida"
                                }
                            </p>
                            <p className='type'>
                                {
                                    props.type ?
                                        props.type
                                        : 'Tipo não definido'
                                }
                            </p>
                        </div>
                        <span className='tag'><p>{props.studentsCount} alunos</p></span>
                    </button>
                    <button className = "class-card-call-lists-report" onClick={props.generateReport}><FaPrint/></button>
                    </>
            }
        </li>
    )
}